// extracted by mini-css-extract-plugin
export default {"scrollimages":"report-form_scrollimages__Z3+CV"};